import { Box, Container, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import SeeMoreButton from "../Common/SeeMoreButton";
import ClientCarousel from "../Common/ClientCarousel";

export default function ClientsPartnersSection({
  showSeeMore,
  data,
  clientSections,
  carouselOptions = {},
}) {
  const navigate = useNavigate();

  // Use clientSections from API if available, otherwise fallback to old data structure
  const sectionsToDisplay = clientSections || [];

  // If using old data structure for backward compatibility
  const allClients = data?.clients || [];
  // const clients = allClients.slice(0, 12);
  const hasMoreClients = allClients.length > 12;

  const defaultSectionData = {
    title: "Our Client",
    description:
      "Trusted by leading organizations across government and private sectors",
  };

  const sectionData = data || defaultSectionData;

  return (
    <Box py={16} bg="transparent">
      <Container maxW="7xl" px={4}>
        {/* Section Header */}
        <VStack spacing={4} textAlign="center" mb={10}>
          <Text
            fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
            fontWeight="bold"
            lineHeight="shorter"
          >
            <Text as="span" color="#000B8C">
              {"Our"}
            </Text>{" "}
            <Text as="span" color="gray.800">
               {"Client"}
            </Text>
          </Text>
          <Text
            fontSize={{ base: "md", md: "lg" }}
            color="gray.600"
            maxW="3xl"
            lineHeight="relaxed"
          >
            {sectionData.description}
          </Text>
        </VStack>

        {/* API-driven Client Sections */}
        {sectionsToDisplay.length > 0 ? (
          sectionsToDisplay.map((section, sectionIndex) => (
            <Box key={sectionIndex} mb={20}>
              <Text
                fontSize={{ base: "2xl", md: "4xl" }}
                fontWeight="bold"
                color="#000B8C"
                textAlign="center"
                mb={6}
              >
                {section.title}
              </Text>
              {section.description && (
                <Text
                  fontSize={{ base: "sm", md: "md" }}
                  color="gray.600"
                  textAlign="center"
                  mb={4}
                  maxW="4xl"
                  mx="auto"
                >
                  {section.description}
                </Text>
              )}
              {/* Client Carousel for this section */}
              <ClientCarousel
                clients={section.clientImages}
                showDots={true}
                autoplay={true}
                autoplaySpeed={4000}
                {...carouselOptions}
              />
            </Box>
          ))
        ) : (
          /* Fallback to old data structure for backward compatibility */
          <Box mb={0}>
            <ClientCarousel 
              clients={allClients} 
              showDots={true}
              autoplay={true}
              autoplaySpeed={4000}
              {...carouselOptions} 
            />
          </Box>
        )}

        {/* See More Button - Show when there are more clients */}
        {/* {sectionsToDisplay.length === 0 && hasMoreClients && (
          <SeeMoreButton
            onClick={() => navigate("/client-partner")}
            text="See More"
            colors={{
              textColor: "black",
              textBorder: "1px solid black",
              textHover: "#000B8C",
              iconBg: "rgba(0, 11, 140, 1)",
              iconHover: "#030b3aff",
            }}
          />
        )} */}
      </Container>
    </Box>
  );
}
